require('./dist/lightbox-dialog/lightbox-dialog.css');
